import {TUploadImage} from '../types/TUploadImage';

/**
 * Decides which local upload tiles a gallery should still render.
 *
 * In a bulk-actions gallery a finished upload tile mirrors an asset persisted in the store.
 * Once that asset is gone — removed by a bulk delete that cannot reach this card's local upload
 * state — the tile must be dropped so a deleted photo does not linger as a ghost.
 *
 * The filter only applies when bulk actions are enabled, which is also the only context where
 * finished uploads are mirrored into the store (no `damageId`). Damage uploads never reach the
 * store, so applying this filter to them would wrongly hide valid tiles — hence the gate.
 *
 * - in-progress upload (not in `uploadedImagesIds`) → kept (still shows its progress bar)
 * - finished upload still present in the store → kept
 * - finished upload whose store asset is gone → dropped (the ghost)
 */
export const getVisibleUploadImages = (
  uploadImages: TUploadImage[],
  uploadedImagesIds: string[],
  storeImageIds: Set<string>,
  isBulkActionsEnabled: boolean
) => {
  if (!isBulkActionsEnabled) {
    return uploadImages;
  }

  const uploadedImageIdsSet = new Set(uploadedImagesIds);

  return uploadImages.filter(
    (image) => !uploadedImageIdsSet.has(image.imageId) || storeImageIds.has(image.imageId)
  );
};
